import React from 'react';
import {
    Button,
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    makeStyles,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { samplePrompt } from '../../Service/ServerAPI';
import SampleQueryCard from './SampleQueryCard';

const useStyles = makeStyles({
    surface: {
        backgroundColor: '#1e1e1e',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        maxWidth: '820px',
        width: '90vw',
        padding: '24px 28px',
    },
    title: {
        color: '#ffffff',
        fontSize: '18px',
        fontWeight: '600',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '12px',
        marginTop: '8px',
    },
});

interface PopupProps {
    handleClose: () => void;
    handleButtonClick: (description: string, index: number) => void;
    isActivision: boolean;
    samplePrompts: samplePrompt[];
}

const QueryPopUp: React.FC<PopupProps> = ({
    handleClose,
    handleButtonClick,
    isActivision,
    samplePrompts,
}) => {
    const classes = useStyles();

    const disabledTooltip = isActivision
        ? 'You cannot generate audience sizes based on play history, app usage or purchases for titles that are outside of the Activision publishing portfolio.'
        : 'Please ensure you have the proper permissions.';

    return (
        <Dialog open={true} onOpenChange={(_, data) => { if (!data.open) handleClose(); }}>
            <DialogSurface className={classes.surface}>
                <DialogBody>
                    <DialogTitle
                        className={classes.title}
                        action={
                            <Button
                                appearance="subtle"
                                icon={<Dismiss24Regular />}
                                onClick={handleClose}
                                style={{ color: '#aaaaaa' }}
                            />
                        }
                    >
                        Sample Queries
                    </DialogTitle>
                    <DialogContent>
                        <div className={classes.grid}>
                            {samplePrompts.map((prompt, index) => (
                                <SampleQueryCard
                                    key={index}
                                    title={prompt.title}
                                    description={prompt.description}
                                    icon={prompt.icon}
                                    disabled={prompt.disabled}
                                    disabledTooltip={disabledTooltip}
                                    onClick={() => handleButtonClick(prompt.description, 10)}
                                />
                            ))}
                        </div>
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default QueryPopUp;